module.exports = __webpack_public_path__ + "static/media/susanne-collins.4873b86f.md";